module.exports = __webpack_public_path__ + "img/u11.6b940601.png";